<svc-modal-bos-type
  svcTestId="bos-modal__modal--type-selector"
  [isAddMode]="modalConfig?.mode === modalTypes.add"
  [class]="shouldDisplayTypeModal ? 'block' : 'hidden'"
  (typeSelected)="setTypeSelected($event)"
  (singleTypeDetected)="handleSingleTypeDetected($event)"
  (closeModal)="dialogRef?.close()"
  (finishLoadType)="onFinishLoadType()"
/>

<ng-container *environment="let env">
  <svc-dialog-primary
    *ngIf="modalConfig?.mode !== modalTypes.add || typeSelected?.label"
    [svcTestId]="'bos-modal__modal--id-' + (bos?.feedbackId ?? 'new')"
    #dialog
    dialogStyle="empty"
    [fullscreen]="['XS', 'SM']"
  >
  <svc-registry-modal-header svc-dialog-title>
    {{ 'BOS' | transloco }}
  </svc-registry-modal-header>

  <div
    svc-dialog-content
    class="flex flex-col overflow-auto flex-auto"
  >
    <div
      [class.hidden]="isInitialLoading"
      class="flex-auto overflow-auto"
    >
      <div
        class="flex items-center justify-center py-30"
        *ngIf="isSaveLoading"
      >
        <mat-spinner diameter="30" />
      </div>

      <div
        class="flex-col gap-4 px-4 pb-4 pt-6"
        [class]="isSaveLoading || isLoading ? 'hidden' : 'flex'"
      >
        <form
          #bosFormContainer
          svcTestId="bos-modal__section--form"
          class="flex flex-col gap-4"
          [formGroup]="formBos"
        >
          <div class="grid grid-cols-2 gap-4 items-start">
            <svc-text
              svcTestId="bos-modal__input--feedback-id"
              formControlName="feedbackId"
              inputId="bos-register-form-id"
              [label]="'Número' | transloco"
              [readonly]="true"
            />

            <svc-text
              *ngIf="showTypeField"
              svcTestId="bos-modal__input--type"
              inputId="bos-register-form-type"
              [formControl]="type"
              [label]="'Tipo' | transloco"
              [readonly]="true"
            />
          </div>

          <div
            class="flex flex-col gap-2"
            *ngIf="(!observerEnabled || modalConfig?.mode === modalTypes.view) && !isLoadingObservers"
          >
            <p class="text-default input-label-size input-label-weight">
              {{ 'Originador' | transloco }}
            </p>

            <div class="flex gap-2">
              <svc-smart-user-avatar
                *ngIf="originatorId"
                [size]="originatorAvatarSize"
                [ids]="originatorId"
              />

              <p
                *ngIf="originatorName"
                class="text-default text-base font-medium"
              >
                {{ originatorName }}
              </p>
            </div>
          </div>

          <svc-chip
            *ngIf="(observerEnabled && modalConfig?.mode !== modalTypes.view) || isLoadingObservers"
            svcTestId="bos-modal__select--originator"
            type="single"
            formControlName="creatorUserId"
            fallbackTextValue="-"
            inputId="bos-register-form-originator"
            [label]="'Originador' | transloco"
            [options]="optionsCombos?.observers"
            (onSelectChanged)="onOriginatorChange($event)"
            [loading]="modalConfig?.mode !== modalTypes.view && isLoadingObservers"
            [readonly]="modalConfig?.mode === modalTypes.view"
          />

          <svc-location-field
            #locationField
            svcTestId="bos-modal__select--location"
            inputId="bos-register-form-location"
            [formControl]="formBos?.controls?.locationId"
            [readonly]="modalConfig?.mode === modalTypes.view"
          />

          <div class="grid grid-cols-2 gap-4 items-start">
            <svc-chip
              svcTestId="bos-modal__select--team"
              type="single"
              formControlName="teamId"
              fallbackTextValue="-"
              inputId="bos-register-form-team"
              [placeholder]="!isTeamFieldMandatory ? ('Opcional' | transloco) : null"
              [label]="'Time Originador' | transloco"
              [options]="optionsCombos?.teams"
              [loading]="isMandatoryTeamFieldLoading || (modalConfig?.mode !== modalTypes.view && isAllCombosLoading)"
              [readonly]="modalConfig?.mode === modalTypes.view"
            />

            <svc-chip
              svcTestId="bos-modal__select--shift"
              type="single"
              formControlName="shiftId"
              fallbackTextValue="-"
              inputId="bos-register-form-shift"
              [label]="'Turno observado' | transloco"
              [options]="optionsCombos?.shifts"
              [loading]="modalConfig?.mode !== modalTypes.view && isAllCombosLoading"
              [readonly]="modalConfig?.mode === modalTypes.view"
            />
          </div>

          <div class="grid grid-cols-2 gap-4 items-start">
            <svc-chip
              svcTestId="bos-modal__select--contractor"
              type="single"
              formControlName="contractorId"
              fallbackTextValue="-"
              inputId="bos-register-form-contractor"
              [placeholder]="'Opcional' | transloco"
              [label]="'Contratista observado' | transloco"
              [options]="optionsCombos?.contractors"
              [loading]="modalConfig?.mode !== modalTypes.view && isAllCombosLoading"
              [readonly]="modalConfig?.mode === modalTypes.view"
            />
          </div>

          <svc-form-custom-field
            #customField
            [applicationId]="applicationId"
            [featureName]="customFieldsFeature.BosType"
            [registryId]="typeSelected?.value"
            [systemReferenceId]="modalConfig?.id"
            [isViewMode]="modalConfig?.mode === modalTypes.view"
          />

          <svc-highlight-group>
            <svc-date-picker
              svcTestId="bos-modal__input--open-date"
              formControlName="openDate"
              inputId="bos-register-form-open-date"
              [label]="'Data de abertura' | transloco"
              [showIcon]="false"
            ></svc-date-picker>

            <svc-date-picker
              svcTestId="bos-modal__input--feedback-date"
              formControlName="feedbackDate"
              inputId="bos-register-form-feedback-date"
              [max]="maxDate"
              [label]="'Data de observação' | transloco"
              [showIcon]="false"
            ></svc-date-picker>
          </svc-highlight-group>
        </form>

        <mat-tab-group
          #tabgroup
          svcTestId="bos-modal__section--tabs"
          mat-stretch-tabs="false"
          mat-align-tabs="center"
        >
          <mat-tab
            svcTestId="bos-modal__tab--bos"
            [label]="'BOS' | transloco"
          >
            <div
              #behaviorsTab
              class="py-4"
            >
            <svc-modal-bos-tab-behaviors
              #tabBehaviors
              [isViewMode]="modalConfig?.mode === modalTypes.view"
              [typeId]="typeSelected?.value"
            />
            </div>
          </mat-tab>

          <mat-tab
            *ngIf="showTabActionPlan || isShowTabActionPlanLoading"
            [disabled]="isShowTabActionPlanLoading"
          >
            <ng-template mat-tab-label>
              {{ 'Planos de ação' | transloco }}
              <ng-container *ngIf="openPlans && !isShowTabActionPlanLoading">
                <mat-icon
                  class="ml-3 mr-1 icon-size-3"
                  svgIcon="heroicons_solid:clipboard-list"
                  [class.text-primary]="tabgroup.selectedIndex === 1"
                />
                <p class="font-normal text-base">{{ completePlans }}/{{ openPlans }}</p>
              </ng-container>
            </ng-template>

            <div
              #actionPlanTab
              svcTestId="bos-modal__section--action-plan"
              class="py-4"
            >
              <svc-actionplan
                #actionPlan
                [id]="modalConfig?.id"
                [applicationId]="applicationId"
                [legacyApplicationId]="legacyApplicationId"
                [originatorId]="bos?.creatorUserId || formBos?.controls?.creatorUserId?.value?.[0]"
                [rolesCreatePermission]="rolesCreatePermission"
                [isViewMode]="modalConfig.mode === SvcModalBosType.view"
                (openPlans)="openPlans = $event"
                (completePlans)="completePlans = $event"
              />
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    @if (isInitialLoading) {
      <svc-modal-bos-skeleton />
    } @else if (bos?.feedbackId && !isLoading) {
      <div class="flex items-center justify-between pl-6 pr-4 py-2 container-actions-shadow">
        @if (!isSaveLoading) {
          <svc-bookmark-button
            svcTestId="bos-modal__icon-btn--bookmark"
            class="w-fit"
            [referenceId]="bos?.feedbackId"
            [applicationId]="applicationId"
            [initialValue]="bos?.isBookmarked"
            [iconAlwaysFilled]="true"
            (onValueChanged)="onBookmarkChanged($event)"
            [textDefaultColor]="true"
            [iconAlwaysFilled]="true"
          />

          <svc-totals-status
            svcTestId="bos-modal__section--totals-status"
            class="h-fit"
            #totalsStatus
            [referenceId]="bos.feedbackId"
            [applicationId]="applicationId"
            [configTypeId]="''"
            [featureName]="featureName"
            [hideIfEmpty]="false"
            [available]="{ reactions: true, views: true, comments: false, actionplans: false }"
          />
        }
      </div>
    }
  </div>
  <div
    svc-dialog-actions-options
    class="flex gap-2 items-center"
  >
    @if (!isInitialLoading) {
      @if (modalConfig?.mode === modalTypes.view) {
        <svc-button-ellipsis
          svcTestId="bos-modal__icon-btn--more-options"
          id="bos-register-more-options"
          [options]="dialogActionOptions"
          color="on-primary"
        />
      }

      @if (modalConfig?.mode !== modalTypes.add && userHasPermissionToEdit) {
        <button
          svcTestId="bos-modal__btn--edit-save"
          svc-outlined-btn
          id="bos-register-edit"
          color="on-primary"
          type="button"
          [processing]="isLoading"
          [disabled]="modalConfig?.mode === modalTypes.view ? false : formBos?.invalid || customField?.formCustomFields?.invalid"
          (click)="setEditMode()"
        >
          {{ (modalConfig?.mode === modalTypes.view ? 'Editar' : 'Salvar') | transloco }}
        </button>
      }

      @if (modalConfig?.mode === modalTypes.add) {
        <button
          svcTestId="bos-modal__btn--close"
          svc-outlined-btn
          color="on-primary"
          type="button"
          id="bos-register-close-add"
          (click)="dialogRef.close()"
        >
          {{ 'Fechar' | transloco }}
        </button>
      } @else {
        <button
          svcTestId="bos-modal__btn--close"
          svc-filled-btn
          color="on-primary"
          type="button"
          id="bos-register-close-view"
          (click)="dialogRef.close()"
        >
          {{ 'Fechar' | transloco }}
        </button>
      }

      @if (modalConfig?.mode === modalTypes.add) {
        <button
          svcTestId="bos-modal__btn--add"
          svc-filled-btn
          id="bos-register-add"
          color="on-primary"
          type="button"
          [disabled]="formBos?.invalid || customField?.formCustomFields?.invalid || isSaveLoading"
          [processing]="isLoading"
          (click)="createOrUpdateFeedback()"
        >
          {{ 'Incluir' | transloco }}
        </button>
      }
    }
  </div>
</svc-dialog-primary>
</ng-container>
